import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  collapsible: {
    minHeight: 70,
    backgroundColor: theme.colorPalette.beige_25
  },
  greenLabel: {
    color: theme.colorPalette.green_80,
    fontWeight: 'normal'
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(4),
    padding: theme.spacing(8)
  },
  empty: {
    extend: 'container',
    justifyContent: 'center',
    fontSize: 16
  },
  icon: {
    height: 32
  },
  sectionContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  label: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2)
  }
});

export default makeStyles(styles);
